export const getItemRequest_v2_schema = {
  type: 'string',
};
